module.exports = __webpack_public_path__ + "img/EOTP_lodge.61b1fb1d.png";